import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../../Loader';

const propTypes = {
  loading: PropTypes.bool.isRequired,
  currentItem: PropTypes.object.isRequired,
};

const defaultProps = {
  body: {},
};

const PartnerPanel = (props) => {

  const { loading } = props;
  const { partner } = props.currentItem;

  const getContent = () => {
    const { website, image_url, location, image_alt, established_date, coordinates, description, title, total_grants, helpful_links } = partner;
    return (
      <div>
        <div className="partner-info-top">
          <div className="float-left partner-logo-container mb-20">
            {
              image_url &&
              <div className="partner-logo text-center">
                <img className="img-fluid" src={image_url.replace('http://', 'https://')} alt={image_alt} />
              </div>
            }
          </div>
          <div className="partner-details mb-20">
            <div className="text-uppercase u-font-foundation-bold u-textSize-18">{title}</div>
            <div className="u-font-foundation-roman u-textSize-18">{location}</div>
            {
              established_date && established_date != '' && established_date != ' ' && established_date != null && established_date != 'null' &&
              <div className="u-font-foundation-roman u-textSize-18">{"Established " + established_date}</div>
            }
            {
              website &&
              <div className="partner-website">
                <a href={website} target="_blank">
                  <button className="video-player-btn text-btn u-font-foundation-roman text-uppercase"><div>Website</div></button>
                </a>
              </div>
            }
          </div>
        </div>

        <div className="partner-separator mt-20 mb-20"></div>

        <div className="text-justify partner-info-blurb" dangerouslySetInnerHTML={{__html: partner.description}} />
        <div className={'text-center'}>
          {
            helpful_links &&
            helpful_links.map(function(link, index){
              return (
                <a className="link-info-wrap" href={link.anchor_link} target="_blank" key={index}>
                  <button className="link-info-btn video-player-btn text-btn u-font-foundation-roman">
                    <div>{link.anchor_text}</div>
                  </button>
                </a>
              );
            })
          }
        </div>
      </div>
    )
  }

  return (
    <div className={`widget panel partner ${loading ? 'loading' : ''}`}>
      {
        loading && !partner ?
        <Loader dark fill /> :
        getContent()
      }
    </div>
  )

}

PartnerPanel.propTypes = propTypes;
PartnerPanel.defaultProps = defaultProps;

export default PartnerPanel;
